module.exports = __webpack_public_path__ + "static/media/29DUNON11.afe167df.jpg";